import appLogoAsset from "../assets/image/login/logo.svg";
import { SITE_URL } from "./envUrls";

export const APP_LOGO_URL = appLogoAsset;
export const APP_FAVICON_URL = `${process.env.PUBLIC_URL || ""}/favicon.png`;

/** Default user avatar when no profile photo is set (`public/farmer-image.png`). */
export const DEFAULT_PROFILE_IMAGE_URL = `${process.env.PUBLIC_URL || ""}/farmer-image.png`;

export const APP_NAME = "CropGen";
export const AI_ASSISTANT_NAME = `${APP_NAME} AI`;
export const AI_ASSISTANT_SHORT = APP_NAME;
export const DASHBOARD_NAV_LABEL = "Dashboard";
export const APP_SITE_URL = SITE_URL;
export const APP_TAGLINE = "Precision Agriculture Solutions";

export const DEFAULT_ORGANIZATION_CODE = "CROPGEN";
export const AUTH_EMAIL_CLIENT_BRAND = "cropgen";
export const AUTH_ROUTES = {
  login: "/login",
  signup: "/signup",
  signupLanguage: "/signup/language",
  signupAccount: "/signup/account",
};
